module.exports = __webpack_public_path__ + "6c4a0dbc/img/delete-icon.eb7de062.svg";